import { createReducer } from "redux-act";
import createAction from "./utils/createMetaAction";
export const updateSequenceCase = createAction("updateSequenceCase");
const newVal = window.localStorage.getItem("uppercaseSequenceMapFont");
export default createReducer(
  {
    [updateSequenceCase]: (state, payload) => {
      localStorage.setItem("uppercaseSequenceMapFont", payload);
      return payload;
    }
  },
  newVal || "noPreference"
  //  noPreference || uppercase || lowercase
);
